import React from "react";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { fetchCollections } from "../../queries/collections/collectionQuery";
import api from "../../utils/api";

class NewAggregatorCollection extends React.Component {
  state = {
    error: {},
    name: "",
    email: "",
    phoneNumber: "",
    isSubmitting: false,
    categories: [],
    status: {
      label: "Active",
      value: true,
    },
    activeBanks: [],
    accountName: "",
  };

  componentDidMount = async () => {
    await this.getCollections(true);

    if (this.props.id) {
      this.setState({
        ...this.props,
      });
    }
  };

  getCollections = async (isLoadingCollections) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingCollections });

      const collections = await fetchCollections(defaultLanguage, {
        listType: "dropdown",
        active: true,
      });

      this.setState({
        collections,
        isLoadingCollections: false,
      });
    } catch (error) {
      this.setState({ isLoadingCollections: false });
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });

    if (field === "channel") {
      this.getActiveBanks(true, e.value);
    }
  }

  validateForm() {
    let { error, collection } = this.state;
    const { aggregatorId } = this.props;

    if (aggregatorId === "") {
      error.aggregator =
        language[this.props.defaultLanguage].aggregator_required;
    }

    if (collection === "") {
      error.collection =
        language[this.props.defaultLanguage].collection_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let { error, status, collection } = this.state;
    const { id, aggregatorId } = this.props;

    let user = await getStorage();

    if (Object.keys(error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      const options = {
        method: "POST",
        url: `${api("core")}/aggregator/till`,
        data: {
          aggregatorId,
          collectionTillId: collection.value,
          active: status.value,
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "aggregator_collection_update_success"
                : "aggregator_collection_added_success"
            ]
          );

          this.props.getData();
          this.props.handleCloseModal();
        })
        .catch((error) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "error",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "aggregator_collection_update_error"
                : "aggregator_collection_add_error"
            ]
          );
        });
    }
  };

  render() {
    return (
      <>
        <div className="card-body">
          <Input
            label={language[this.props.defaultLanguage].aggregator}
            value={this.props.aggregatorName}
            error={this.state.error.aggregator}
            disabled
          />
          <Select
            options={this.state.collections}
            label={language[this.props.defaultLanguage].collection}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.aggregator}
            onChange={(e) => this.onChangeInput("collection", e)}
            error={this.state.error.collection}
            isLoading={this.state.isLoadingCollections}
          />
          <Select
            options={[
              { label: "Active", value: "true" },
              { label: "Inactive", value: "false" },
            ]}
            label={language[this.props.defaultLanguage].status}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.status}
            onChange={(e) => this.onChangeInput("status", e)}
            error={this.state.error.status}
          />
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewAggregatorCollection);
